import { Component } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { CustomValidator } from 'src/app/customValidator';
import { MaterialModule } from 'src/app/material.module';
import { AlertService } from 'src/app/services/alert.service';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [RouterModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {
  userInfo:any;
  isSubmit:boolean = false;
  showVarPassword:boolean=false;
  newVarPassword:boolean=false;
  constructor(private fb: FormBuilder,
    private userService: UserService,
    private sharedService: SharedService,
    private alertService: AlertService
  ){
    this.userInfo = this.sharedService.userInfo;
  }

  newPasswordForm = this.fb.group({
    oldPassword: [null, Validators.required],
    password : [null, Validators.compose([
      Validators.required,
      CustomValidator.patternValidator(/\d/, { hasNumber: true }),
      CustomValidator.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
      CustomValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
      CustomValidator.patternValidator(/[-._!"`'#%&,:;<>=@{}~\$\(\)\*\+\/\\\?\[\]\^\|]+/, { hasSpecialCharacters: true }),
      Validators.minLength(8), Validators.maxLength(20)
      ])
    ],
    confirmPassword :['', Validators.required],
  },
  {
    validator: CustomValidator.passwordMatchValidator
  })

  get newPass() {
    return this.newPasswordForm.controls;
  }


  changePassword(fvalue:any){
    if(this.newPasswordForm.invalid) {
      return;
    }
    if(fvalue.password !==  fvalue.confirmPassword){
        this.alertService.warning('Confirm password and password not matched');
        return;
    }
    let body={
      "user_id": this.userInfo.user_id,
      "new_password": fvalue.password,
      "old_password": fvalue.oldPassword
    };
    if(!this.isSubmit) {
        this.isSubmit = true;
        this.userService.updatePassword(body).subscribe({
          next: (res: any) => {
            this.newPasswordForm.reset();
            this.isSubmit = false;
            if (res && res.status == 201) {
              this.alertService.success(res.message);
            }
            else {
              this.alertService.warning(res.message);
            }
          },
          error: (err:any) => {
            this.newPasswordForm.reset();
            this.isSubmit = false;
            this.alertService.warning(err.error.message);
          }
        })
      }
  }

}
